import React from 'react';
import { Box, Typography, Avatar, useMediaQuery, useTheme } from '@mui/material';
import profileimage from '../../assets/dashboard/category.png'

const Header = ({ title, user }) => {
    const theme = useTheme();
    const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <>
            {!isMediumScreen &&
                <Box
                    sx={{
                        py: isMediumScreen ? 1.5 : 2.5,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderBottom: '0.5px solid #E0E0E0',
                        position: 'sticky',
                        top: 0, zIndex: 111,
                        backgroundColor:'#F2F8FB'
                    }}
                >
                    <Typography variant="h4">{title}</Typography>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar src={profileimage} alt={"Profile"} sx={{ width: 40, height: 40 }} />
                        <Box>
                            <Typography variant="body1" sx={{ fontWeight: 600 }}>Liza Roy</Typography>
                            <Typography variant="body2" sx={{ color: 'gray' }}>Admin</Typography>
                        </Box>
                    </Box>
                </Box>
            }
        </>
    );
};

export default Header;